module.exports = __webpack_public_path__ + "static/services-details1-b6243bbb3b255a0b2667472c7d5a12cb.jpg";